import { render, staticRenderFns } from "./AddMessageModal.vue?vue&type=template&id=183dbb30&scoped=true&"
import script from "./AddMessageModal.vue?vue&type=script&lang=js&"
export * from "./AddMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMessageModal.vue?vue&type=style&index=0&id=183dbb30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183dbb30",
  null
  
)

export default component.exports